import { Dispatch, SetStateAction, useCallback } from 'react';
import { useRegisterResponseAction } from '../../context/useRegisterResponseAction';

export const useStoreAlwaysAction = (
  setForceSave: Dispatch<SetStateAction<boolean>>
): void => {
  const handler = useCallback(
    (params: unknown) => {
      setForceSave(Boolean(params));
    },
    [setForceSave]
  );

  useRegisterResponseAction('storeAlways', handler);
};
